import {
  Box,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  IconButton,
} from "@chakra-ui/react";
import { Search, X } from "lucide-react";
import { useKiosk } from "../../Contexts/KioskContext";

/*
 An interactive search bar component used to search for tools.
*/
function SearchBar({ query, setQuery, placeholder }) {
  const { isKiosk } = useKiosk();

  const handleClearQuery = () => {
    setQuery("");
  };

  const inputHeight = isKiosk ? 14 : 10;

  return (
    <Box width={isKiosk ? "full" : "xl"} maxW="full">
      <InputGroup>
        <InputLeftElement
          pointerEvents="none"
          h={inputHeight}
          w={inputHeight}
        >
          <Box as={Search} color="gray.500" boxSize={isKiosk ? 5 : 4} aria-hidden="true" />
        </InputLeftElement>
        <Input
          type="text"
          aria-label={placeholder || "Search tools by name or category"}
          placeholder={placeholder || "Search tools"}
          variant={isKiosk ? "outline" : "filled"}
          borderRadius="full"
          value={query}
          onChange={(event) => setQuery(event.target.value)}
          {...(!isKiosk && { _hover: { borderColor: "gray.300" } })}
          _focus={{ borderColor: "brand.red", boxShadow: "outline" }}
          pl={inputHeight}
          pr={inputHeight}
          h={inputHeight}
          fontSize={isKiosk ? "xl" : "md"}
          borderWidth={isKiosk ? "2px" : undefined}
        />
        <InputRightElement h={inputHeight} w={inputHeight}>
          {query ? (
            <IconButton
              aria-label="Clear search query"
              icon={<Box as={X} boxSize={isKiosk ? 3 : 2.5} aria-hidden="true" />}
              variant="ghost"
              size={isKiosk ? "md" : "sm"}
              minW="48px"
              minH="48px"
              rounded="full"
              onClick={handleClearQuery}
            />
          ) : null}
        </InputRightElement>
      </InputGroup>
    </Box>
  );
}

export default SearchBar;
